import * as R from 'ramda'

import {
  getDefaultDescription,
  getDefaultTitle,
} from 'components/DocumentHead/helpers'
import { inject } from 'helpers/mobx'
import { IStoreProvider } from 'store'
import { IDocumentHead } from '.'

export default component =>
  inject(
    (store: IStoreProvider, props: Partial<IDocumentHead>) => {
      const t = store.t
      const currentPath = store.urlManagerStore.pathname
      const defaultTitle = getDefaultTitle({
        t,
        pathname: currentPath,
        brandCount: store.configStore.brandCount,
        locale: store.localeStore.locale,
      })

      const { excludeLocales, ...passthroughProps } = props

      const defaultDescription = getDefaultDescription({
        t,
        locale: store.localeStore.locale,
        pathname: currentPath,
        returnDays: store.configStore.returnDays,
        deliveryDays: store.configStore.deliveryDays,
        brandCount: store.configStore.brandCount,
      })

      const disabledCountries = store.featureStore.getDisabledExpansionLocales()
      const propsExcludedLocales = props.excludeLocales
        ? props.excludeLocales
        : []
      const mergedExcludedLocales = [
        ...disabledCountries,
        ...propsExcludedLocales,
      ]

      return {
        isCzech: store.localeStore.locale === 'cs_CZ',
        shouldAppendOrganizationJSONLD: store.featureStore.isActive(
          'enableOrganizationJSONLD',
        ),
        defaultTitle,
        defaultDescription,
        locale: store.localeStore.locale,
        currentPath,
        currentUrl: store.urlManagerStore.href,
        isNotFoundPage: R.includes('not-found', currentPath),
        environment: store.urlManagerStore.environment,
        originByLocaleMap: store.urlManagerStore.originByLocaleMap,
        mobileOriginByLocaleMap: store.urlManagerStore.mobileOriginByLocaleMap,
        excludeLocales: mergedExcludedLocales,
        hrefLangsRelatedToLocale:
          store.urlManagerStore.hrefLangsRelatedToLocale,
        ...passthroughProps,
      }
    },
    { observe: true },
  )(component)
